import { CheckRow } from '@workspace/ui/components/check-row'
import type { StatusTone } from '@workspace/ui/components/status-row'
import { StatusRow } from '@workspace/ui/components/status-row'
import type { DiagnosticRow } from './types'

/**
 * A calm campaign state: what it is doing, and what is safe.
 *
 * Used where nothing is wrong but nothing is sending either — paused by the
 * founder, or disconnected by their own choice. The rows exist to answer the
 * question those states raise, which is "did I lose anything".
 */
export function StatusVisual({
  statusLabel,
  statusDetail,
  statusTone,
  rows,
}: {
  statusLabel: string
  statusDetail?: string
  statusTone: StatusTone
  rows: DiagnosticRow[]
}) {
  return (
    <div className="rounded-xl border border-border/40 bg-card/40 px-5 py-4">
      <StatusRow tone={statusTone} label={statusLabel} detail={statusDetail} className="mb-2.5" />
      {rows.map((row) => (
        <CheckRow key={row.text} tone={row.tone}>
          {row.text}
        </CheckRow>
      ))}
    </div>
  )
}
